import { format } from 'date-fns';
import type { CommonHTMLTimeAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { useGetRelativeLabel } from '../../utils/thread-utils';

type ThreadDateTimeDividerProps = {
  timestamp: Date;
} & CommonHTMLTimeAttributes;

export const ThreadDateTimeDivider = ({ timestamp, ...rest }: ThreadDateTimeDividerProps) => {
  const dayLabel = useGetRelativeLabel(timestamp);

  return (
    <time
      css={{
        width: '100%',
        display: 'block',
        textAlign: 'center',
        color: theme.colors.neutral50,
        paddingBottom: theme.spacing(2),
      }}
      {...rest}
    >
      {dayLabel && (
        <span
          css={{
            display: 'inline-flex',
            alignItems: 'center',
            '&::after': {
              content: '""',
              display: 'inline-block',
              width: 3,
              height: 3,
              marginInline: theme.spacing(0.75),
              borderRadius: '50%',
              backgroundColor: theme.colors.neutral50,
            },
          }}
        >
          {dayLabel}
        </span>
      )}
      {format(timestamp, 'PP')}
    </time>
  );
};
